const DEFAULT_FORMATS = {
  date: "yyyy-MM-dd",
  month: "yyyy-MM",
  datetime: "yyyy-MM-dd hh:mm:ss",
  time: "hh:mm:ss",
  year: "yyyy"
}

// 判断是否是日期格式
export const IsDate = (str) => {
  str = str.replace("-", "/")
  var date = new Date(str)
  return !isNaN(date.getTime())
}

// 日期格式化
export const FormatDate = (date, format = "datetime", defaultVal) => {

  if (!date || !format) { return defaultVal??"" }
  
  if (Object.keys(DEFAULT_FORMATS).includes(format)) {
    const newFormat = format
    format = DEFAULT_FORMATS[newFormat]
  }
  
  if (!(date instanceof Date)) {
    if (typeof date === "number" || IsDate(date)) { date = new Date(date) } else { date = new Date(Number(date)) }
  }
  
  const o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
    "q+": Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, String(date.getFullYear()).substr(4 - RegExp.$1.length))
  }
  
  for (const k in o) {
    const reg = new RegExp(`(${k})`)
    if (reg.test(format)) {
      format = format.replace(reg, (RegExp.$1.length === 1) ? o[k] : ("00" + o[k]).substr(String(o[k]).length))
    }
  }

  return format
}